import { bl_dgmkt_project_event_RowClass } from '../../../dbschema/bl_dgmkt_project_event.model';
import { BaseContainerModel } from '../../base-container.model';


export class DgMktProjectEventContainerModel extends BaseContainerModel {
  bl_dgmkt_project_event: bl_dgmkt_project_event_RowClass = new bl_dgmkt_project_event_RowClass();
}
